import { createFileRoute, useRouterState } from "@tanstack/react-router";
import { ErrorPageActions } from "@/components/error/error-page-actions";

export function Error404Component() {
	const pathname = useRouterState({ select: (s) => s.location.pathname });
	const looksLikeInboxURL =
		pathname.includes("/inbox/") || pathname === "/inbox";

	return (
		<div className="flex flex-col items-center justify-center min-h-[80vh] p-8 text-center">
			<h1 className="text-4xl font-bold mb-4">🤷‍♂️ 404 - Page Not Found</h1>

			<div className="mb-8">
				<img
					src="https://http.dog/404.jpg"
					alt="404 dog"
					className="rounded-lg shadow-lg max-w-md mx-auto dark:brightness-90"
				/>
			</div>

			<div className="max-w-lg mx-auto space-y-4">
				<p className="text-xl mb-4">
					Oops! The page you're looking for doesn't exist.
				</p>

				{looksLikeInboxURL ? (
					<div className="rounded-lg border border-amber-500/35 bg-amber-500/[0.07] px-4 py-3 text-left text-sm text-muted-foreground dark:border-amber-500/30 dark:bg-amber-500/10">
						<p className="font-medium text-foreground">
							Looks like a disposable inbox URL
						</p>
						<p className="mt-2 leading-relaxed">
							Inbox links only work for the exact path you were given when the
							address was created. A typo, a truncated copy, or an old bookmark
							can all land here. If the mailbox expired or was cleared, you will
							need a new address from the home page.
						</p>
					</div>
				) : null}

				<div className="text-gray-600 dark:text-gray-400">
					<p>Here are a few things you can try:</p>
					<ul className="list-disc list-inside mt-2">
						<li>Check the URL for typos</li>
						<li>Go back to the previous page</li>
						<li>Head to the home page</li>
					</ul>
				</div>
			</div>

			<ErrorPageActions />
		</div>
	);
}

/* istanbul ignore start -- TanStack Router file route registration */
export const Route = createFileRoute("/_error/404")({
	// Prerendered to dist/404.html and served for unmatched paths; never index it.
	head: () => ({
		meta: [
			{ title: "Page not found" },
			{ name: "robots", content: "noindex, nofollow" },
		],
	}),
	component: Error404Component,
});
/* istanbul ignore end */
